(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('.sa-product-gallery').forEach(gallery => {
      if (gallery.dataset.saReady) return;
      gallery.dataset.saReady = 'true';
      const list = gallery.querySelector('.sa-gallery-items');
      const slides = [...list.children];
      const nav = gallery.querySelector('.sa-gallery-navigation');
      const buttons = [...nav.querySelectorAll('button')];
      const status = gallery.querySelector('.sa-gallery-status');
      const mobile = window.matchMedia('(max-width: 749px)');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let scheduled = false;
      function select(index) {
        if (index === current && buttons[index].getAttribute('aria-current') === 'true') return;
        current = index;
        buttons.forEach((button, n) => {
          button.classList.toggle('is-selected', n === index);
          button.setAttribute('aria-current', String(n === index));
        });
        status.textContent = `Afbeelding ${index + 1} van ${slides.length}`;
        const button = buttons[index];
        const buttonBox = button.getBoundingClientRect();
        const navBox = nav.getBoundingClientRect();
        nav.scrollTo({left: nav.scrollLeft + buttonBox.left - navBox.left - (nav.clientWidth - buttonBox.width) / 2, behavior: 'auto'});
      }
      function go(index) {
        const next = Math.max(0, Math.min(slides.length - 1, index));
        const left = slides[next].offsetLeft - slides[0].offsetLeft;
        list.scrollTo({left, behavior: reduced.matches ? 'auto' : 'smooth'});
        select(next);
      }
      buttons.forEach((button, index) => button.addEventListener('click', () => go(index)));
      nav.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = current + 1;
        if (event.key === 'ArrowLeft') next = current - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = slides.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        next = Math.max(0, Math.min(slides.length - 1, next));
        go(next);
        buttons[next].focus({preventScroll: true});
      });
      list.addEventListener('scroll', () => {
        if (!mobile.matches || scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          const left = list.scrollLeft + slides[0].offsetLeft;
          let index = 0;
          slides.forEach((slide, n) => {
            if (Math.abs(slide.offsetLeft - left) < Math.abs(slides[index].offsetLeft - left)) index = n;
          });
          select(index);
          scheduled = false;
        });
      }, {passive: true});
      mobile.addEventListener('change', () => {
        if (mobile.matches) go(current);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
